const RegistrationAccountStatus = Object.freeze({
  REGISTERING: 'Registering',
  CONFIRMING: 'Confirming',
  EDITING: 'Editing',
} as const);

export type RegistrationAccountStatus = (typeof RegistrationAccountStatus)[keyof typeof RegistrationAccountStatus];

export default RegistrationAccountStatus;
